import determineBenefitStatus from "../BenefitTilesHandler/determineBenefitStatus.js";

/**
 * Determines whether the "Waive" or "Reinstate" Premium options should be visible.
 * @param {Object} coverage - The coverage object.
 * @param {Object} user - The user object.
 * @returns {{ showWaivePremiumsOption: boolean, showReinstatePremiumsOption: boolean }}
 */
function getBenefitEligibility(coverage, user) {
    if (!coverage) {
        return { showWaivePremiumsOption: false, showReinstatePremiumsOption: false }; 
    }

    const coverageEntries = Object.entries(coverage);

    // Normalize the data
    const benefitStates = coverageEntries
        .filter(([ name ]) => name !== 'spendingAccounts')
        .map(([ name, data ]) => {
            const { status } = determineBenefitStatus(data, name, user);
            const isActiveOrEligible = [ 'Active', 'Not Eligible' ].includes(status);
            const isCurrentlyWaived = data.isPremiumWaived === 1 && Boolean(data.premiumWaivedEffectiveDate);
            return { isActiveOrEligible, isCurrentlyWaived };
        });

    const showWaivePremiumsOption = benefitStates
        .filter((b) => b.isActiveOrEligible && !b.isCurrentlyWaived)
        .length >= 1;

    const showReinstatePremiumsOption = benefitStates
        .filter((b) => b.isActiveOrEligible && b.isCurrentlyWaived)
        .length >= 1;

    return {
        showWaivePremiumsOption,
        showReinstatePremiumsOption
    };
}

export default getBenefitEligibility;